module.exports = __webpack_public_path__ + "img/category-spellcasting-reverse.065d21f8.svg";